import { Link } from 'react-router-dom'
import { openContactModal } from './ContactModal'

type FooterLink =
  | { label: string; to: string }
  | { label: string; href: string; external?: boolean }

const FOOTER_GROUPS: Array<{ title: string; links: FooterLink[] }> = [
  {
    title: 'Product',
    links: [
      { label: 'How it works', href: '/#how' },
      { label: 'What is TokenDance?', to: '/what-is-TokenDance' },
      { label: 'LLM', to: '/' },
      { label: 'FDE teams', to: '/fde' },
    ],
  },
  {
    title: 'Resources',
    links: [
      { label: 'Docs', to: '/docs' },
      { label: 'FAQ', to: '/why' },
      { label: 'Talk to us', href: 'mailto:hi@tokendance.net' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { label: 'Terms of Service', to: '/terms' },
      { label: 'Privacy Policy', to: '/privacy' },
      { label: 'Acceptable Use Policy', to: '/aup' },
    ],
  },
]

function FooterLogo() {
  return (
    <span className="od-footer-logo" aria-hidden="true">
      <img className="td-logo-on-dark" src="/logo.png" alt="" decoding="async" />
      <img className="td-logo-on-light" src="/logo-on-light.png" alt="" decoding="async" />
    </span>
  )
}

function FooterLinkItem({ link }: { link: FooterLink }) {
  if ('to' in link) {
    return (
      <Link className="od-footer-link" to={link.to}>
        {link.label}
      </Link>
    )
  }

  return (
    <a
      className="od-footer-link"
      href={link.href}
      target={link.external ? '_blank' : undefined}
      rel={link.external ? 'noopener noreferrer' : undefined}
      onClick={(event) => {
        if (link.href.startsWith('mailto:hi@tokendance.net')) {
          event.preventDefault()
          openContactModal()
        }
      }}
    >
      {link.label}
    </a>
  )
}

export default function Footer() {
  return (
    <footer className="od-footer" aria-label="Footer">
      <div className="od-footer-inner">
        <div className="od-footer-brand">
          <Link to="/" className="od-footer-brand-link" aria-label="TokenDance home">
            <FooterLogo />
          </Link>
          <p>Managed model APIs and token infrastructure for commercial AI.</p>
          <a
            className="od-footer-email"
            href="mailto:hi@tokendance.net"
            onClick={(event) => {
              event.preventDefault()
              openContactModal()
            }}
          >
            hi@tokendance.net
          </a>
        </div>

        <div className="od-footer-links" aria-label="Footer navigation">
          {FOOTER_GROUPS.map((group) => (
            <section key={group.title} className="od-footer-group">
              <h2>{group.title}</h2>
              <div>
                {group.links.map((link) => (
                  <FooterLinkItem key={link.label} link={link} />
                ))}
              </div>
            </section>
          ))}
        </div>

        <div className="od-footer-bottom">
          <p>&copy; 2026 tokendance.net. All rights reserved.</p>
        </div>
      </div>
    </footer>
  )
}
